import { environment } from '@quartz-gov-legacy/environments/environment';
﻿
(function () {
    'use strict';

    angular
        .module('businessUnitModule')
        .factory('businessUnitService', service);

    service.$inject = ['$http'];

    function service($http) {
        var baseUrl = environment.apiUrl + '/Pilot/api/BusinessUnit';

        function returnData(response) {
            return response.data;
        }

        return {
            // Get All Business Units
            getAllBusinessUnits: function () {
                return $http
                    .get(baseUrl)
                    .then(returnData);
            },

            // Search
            searchBusinessUnit: function (searchTerm) {
                return $http
                    .get(baseUrl + '/Search/' + searchTerm)
                    .then(returnData);
            }
        }
    }
})();
